import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to Data Analysis",
    points: [
      "What is Data Analysis and its importance",
      "Types of data: structured and unstructured",
      "Data analysis lifecycle and workflow",
      "Real-world use cases in business and industry",
    ],
  },
  {
    title: "Excel for Data Analysis",
    points: [
      "Basic to advanced Excel functions",
      "Pivot Tables and Pivot Charts",
      "Data cleaning and formatting techniques",
      "Conditional formatting and data validation",
    ],
  },
  {
    title: "SQL for Data Analysis",
    points: [
      "Introduction to databases and SQL",
      "SELECT queries, filtering, and sorting",
      "Joins (INNER, LEFT, RIGHT, FULL)",
      "Aggregations, GROUP BY, and subqueries",
    ],
  },
  {
    title: "Python for Data Analysis",
    points: [
      "Python setup for data analysis",
      "Working with Pandas for data manipulation",
      "NumPy for numerical operations",
      "Data cleaning and transformation techniques",
    ],
  },
  {
    title: "Data Visualization",
    points: [
      "Introduction to data visualization concepts",
      "Creating charts using Matplotlib",
      "Advanced visualization with Seaborn",
      "Building dashboards using Power BI and Tableau",
    ],
  },
  {
    title: "Statistics for Data Analysis",
    points: [
      "Descriptive statistics (mean, median, mode)",
      "Probability basics and distributions",
      "Correlation and regression analysis",
      "Hypothesis testing fundamentals",
    ],
  },
  {
    title: "Business Intelligence",
    points: [
      "Understanding KPIs and business metrics",
      "Data-driven decision making",
      "Reporting techniques for stakeholders",
      "Dashboard creation for business insights",
    ],
  },
  {
    title: "Tools & Reporting",
    points: [
      "Advanced Excel dashboards",
      "Power BI reports and visuals",
      "Tableau interactive dashboards",
      "Automating reports and insights generation",
    ],
  },
  {
    title: "Projects & Case Studies",
    points: [
      "Real-time business data analysis projects",
      "Sales and marketing data analysis",
      "Customer behavior analysis",
      "End-to-end data reporting projects",
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive Data Analysis syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
